import { render, staticRenderFns } from "./PipelineLabel.vue?vue&type=template&id=6b4967e9&"
import script from "./PipelineLabel.vue?vue&type=script&lang=ts&"
export * from "./PipelineLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports